/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputPositionUpdate
 */
export interface InputPositionUpdate {
    /**
     * 
     * @type {string}
     * @memberof InputPositionUpdate
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof InputPositionUpdate
     */
    name: string;
}

/**
 * Check if a given object implements the InputPositionUpdate interface.
 */
export function instanceOfInputPositionUpdate(value: object): boolean {
    if (!('name' in value)) return false;
    return true;
}

export function InputPositionUpdateFromJSON(json: any): InputPositionUpdate {
    return InputPositionUpdateFromJSONTyped(json, false);
}

export function InputPositionUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputPositionUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'comment': json['comment'] == null ? undefined : json['comment'],
        'name': json['name'],
    };
}

export function InputPositionUpdateToJSON(value?: InputPositionUpdate | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'comment': value['comment'],
        'name': value['name'],
    };
}

